import { HttpService } from '@nestjs/axios'
import { Injectable } from '@nestjs/common'
import { IsIn, IsNumber } from 'class-validator'
import { Transaction } from 'sequelize'
import { CRMMessageDto, WhastAppMessageEstatusesDto } from '@decet/sistema-mensajes-shared'
import { MensajeRecibidoModel } from '../models/mensaje-recibido.model'

export class WebhookMensajeDto {
  @IsNumber()
  cuentaId!: number

  @IsIn(['default', 'text', 'image', 'video', 'document'])
  tipoMensaje!: 'default' | 'text' | 'image' | 'video' | 'document'

  mensaje: any
}

@Injectable()
export class WebhookListenerService {
  constructor(private httpClient: HttpService) {}

  async statuses(data: WhastAppMessageEstatusesDto, url: string) {
    this.httpClient.post(`${url}/statuses`, data).subscribe()
  }

  async agregar(
    cuenta,
    mensajes: WebhookMensajeDto[],
    data: CRMMessageDto[],
    transaction?: Transaction,
  ): Promise<void> {
    const response = await MensajeRecibidoModel.bulkCreate(mensajes, { transaction })
    this.httpClient.post(cuenta.redirect, data).subscribe({
      error: (error) => {
        //TODO: enviar el porque trono a algún bug o correo
        console.error(error)
        const ids = response.map((i) => i.id)
        MensajeRecibidoModel.update({ rechazado: true }, { where: { id: ids }, transaction })
      },
    })
  }
}
